/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PublishWarning from '../publishwarning/publishwarning';
import { revertProductManagerConfigChanges } from 'state/slices/productmanager';

// material
import { displayModal } from '@insticator/insticator-ui'
import Space from 'material/space/space';
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as Code } from 'assets/icons/code.svg'
// content
import Additional from './additional/additional';
// styles
import injectSheet from 'react-jss'
import styles from './codesetup_styles'
import Basic from './basic/basic';


/* ========== ~~~~~~~~~~ MODERATION CONFIG V2: GENERAL SECTION ~~~~~~~~~~ ========== */
const CodeSetup = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const { productManagerConfig, tempProductManagerConfig } = useSelector(state => state.productManager)


  const [isOpened, setIsOpened] = useState(false)

  const handleToggle = () => setIsOpened(!isOpened)

  const showPublishWarning = () => dispatch(displayModal(true, <PublishWarning  />, false))

  const handleCancel = useCallback(async () => {
    await dispatch(revertProductManagerConfigChanges())
    setIsOpened(!isOpened)
  }, [dispatch, isOpened])

  const isProductManagerConfigChanged = useMemo(() => {
    return !(JSON.stringify(productManagerConfig) === JSON.stringify(tempProductManagerConfig));
  },[productManagerConfig, tempProductManagerConfig])

  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      handleToggle={handleToggle}
      // handleSave={showPublishWarning}
      // disableSave={!isProductManagerConfigChanged}
      // handleCancel={handleCancel}
      // disableCancel={!isProductManagerConfigChanged}
      // saveTitle={'Save Changes'}
      icon={<Code />}
      title='Code Integration'
    />
  );

  return (
    <ExpandableSection
      className={`expandablesectionv2 codesetup ${props.classes.codesetup}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
    >
      <Space>
        <Basic />
        <Additional />
      </Space>
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CodeSetup;